export const UNDERWRITTEN_MAXIMUM_PREFIX = 'UnderwrittenMaximum_';

export const UNDERWRITTEN_MAXIMUM_COVER_TYPES: { key: string; label: string }[] = [
    { key: 'LifeCover', label: 'Life Cover' },
    { key: 'SevereIllnessCover', label: 'Severe Illness Cover' },
    { key: 'ImpairmentCover', label: 'Impairment Cover' },
    { key: 'IncomeProtection90DayWP', label: 'Income Protection 90 day WP' },
    { key: 'IncomeProtection30DayWP', label: 'Income Protection 30 day WP' },
];

export function buildUnderwrittenMaximumDisclosureType(coverKey: string): string {
    return `${UNDERWRITTEN_MAXIMUM_PREFIX}${coverKey}`;
}

export interface UnderwrittenMaximumFormState {
    coverKey: string;
    disclosureGroupId?: string;
    value: string;
}
